import React, { useContext, useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui';
import { Navigation } from '../components/Navigation';
import { SideBar } from '../components/SideBar';
import { AuthContext } from '../context/AuthContext';
import { SideBarContext } from '../context/SideBarContext';
import './swagger-ui.css';

export const Swagger = () => {
    const { token } = useContext(AuthContext);
    const [service, setService] = useState<string>('user-service');
    useEffect(() => {
        SwaggerUI({
            url: `${process.env.REACT_APP_API_URL}${service}/swagger`,
            requestInterceptor: (req) => {
                req.headers.Authorization = `Bearer ${token}`;
                return req;
            },
            dom_id: '#swagger',
        });
    }, [service]);
    const { sideBarVissible } = useContext(SideBarContext);
    return (
        <div className={`d-flex wrapper swagger ${sideBarVissible && 'sidebar-active'} w-100`}>
            <SideBar>
                <Navigation />
            </SideBar>
            <div className='content-wrapper w-100'>
                <select onChange={(e) => setService(e.target.value)}>
                    <option value='user-service'>User service</option>
                    <option value='client-service'>Client service</option>
                    <option value='warehouse-service'>Warehouse service</option>
                    <option value='work-service'>Work service</option>
                    <option value='timer-service'>Timer service</option>
                    <option value='logger-service'>Logger service</option>
                    <option value='configuration-service'>Configuration service</option>
                </select>
                <div id='swagger'></div>
            </div>
        </div>
    );
};
